import { render, staticRenderFns } from "./menumanager.vue?vue&type=template&id=0691fd18&scoped=true&"
import script from "./menumanager.vue?vue&type=script&lang=js&"
export * from "./menumanager.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=0691fd18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0691fd18",
  null
  
)

export default component.exports